import { BlockDefinition } from "./types";

export const blockIsMapped = (def: BlockDefinition) =>
    // both collection and dataSource are non-nullable according to the type
    // but it would take a larger refactor to reflect their nullability accurately
    !!def.collection?.dataSource?.isComplete;
export const isDetailsBlock = (def: BlockDefinition): boolean =>
    def.name.startsWith("list-details") || isVibeDetailsBlock(def);

function isVibeDetailsBlock(def: BlockDefinition): boolean {
    return (
        def.name === "vibe-coding" &&
        (def.elements.metadata?.blockType === "list-details-auto" ||
            def.elements.metadata?.blockType === "list-details-current")
    );
}
